import { render, staticRenderFns } from "./DataMasterCreate.vue?vue&type=template&id=080783c6&lang=pug"
import script from "./DataMasterCreate.vue?vue&type=script&lang=js"
export * from "./DataMasterCreate.vue?vue&type=script&lang=js"
import style0 from "./DataMasterCreate.vue?vue&type=style&index=0&id=080783c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports